import { Bracket, DependencyTextMap, Seed } from "core/models/Bracket"

export function buildDependencyTextMap(brackets: Bracket): DependencyTextMap {
  const seeds = generateAllBrackets(brackets)
  const byId = new Map<string, Seed>(seeds.map((b) => [b.id, b]))
  const result: DependencyTextMap = new Map()

  for (const b of seeds) {
    const slots: [string, string] = ['', '']
    const deps = b.dependencies ?? []

    const labels = deps.map((dep) => {
      const src = byId.get(dep.sourceBracketId)
      const matchNum = src?.matchNumber
      return `${dep.teamSource === 'winner' ? 'Winner' : 'Loser'} of Match ${matchNum ?? '?'}`
    })

    if (labels.length === 1) {
      slots[1] = labels[0]
    } else if (labels.length >= 2) {
      slots[0] = labels[0]
      slots[1] = labels[1]
    }

    result.set(b.id, slots)
  }

  return result
}

function generateAllBrackets(bracket: Bracket) {
  const allBrackets: Seed[] = []

  if (bracket?.upper?.length) {
    allBrackets.push(...bracket.upper.flatMap((r) => r.seeds))
  }
  if (bracket?.lower?.length) {
    allBrackets.push(...bracket.lower.flatMap((r) => r.seeds))
  }
  if (bracket?.final?.length) {
    allBrackets.push(...bracket.final.flatMap((r) => r.seeds))
  }
  if (bracket?.thirdPlace?.length) {
    allBrackets.push(...bracket.thirdPlace.flatMap((r) => r.seeds))
  }

  return allBrackets
}
